import { trackEvent } from "../../utils/FunctionsGlobals";
import { genMetaEventId, resolvePixelId, sendMetaCapiEvent, trackMetaEvent } from "../../utils/metaPixel";

const normalizeName = (value: unknown): string =>
    typeof value === 'string' ? value.trim().toLowerCase() : '';

const normalizeEmail = (value: unknown): string =>
    typeof value === 'string' ? value.trim().toLowerCase() : '';

const normalizePhone = (value: unknown): string =>
    typeof value === 'string' ? value.replace(/\D/g, '') : '';

const sha256Hex = async (value: string): Promise<string> => {
    if (!value) return '';

    const subtle = typeof window !== 'undefined' ? window.crypto?.subtle : undefined;
    if (!subtle) return '';

    const data = new TextEncoder().encode(value);
    const digest = await subtle.digest('SHA-256', data);

    return Array.from(new Uint8Array(digest))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');
};

export const trackLead = (site: any, property: any) => {
    if (site?.tag_google_head || site?.google_analytics_head) {
        trackEvent("whatsapp_click", { source: "whatsapp_click" });
    }

    // Meta (Pixel + CAPI) SÓ com imóvel (property?.id). Fonte de pixel = Pixel ID resolvível
    // (fb_id_pixel limpo OU extraído do snippet legado). O token não vive mais no cliente.
    const shouldTrackLead = Boolean(
        property?.id && resolvePixelId(site?.fb_id_pixel, site?.pixel_facebook_head)
    );

    if (!shouldTrackLead || typeof window === 'undefined') {
        return;
    }

    // eventId único compartilhado pelas DUAS pernas (a Meta dedupa Pixel×CAPI pelo mesmo id + nome).
    const eventId = genMetaEventId();

    void (async () => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const normalizedName = normalizeName(user?.name);
        const normalizedEmail = normalizeEmail(user?.email);
        const normalizedPhone = normalizePhone(user?.telephone);
        const normalizedId = user?.id_client ? String(user.id_client) : '';

        const [hashNome, hashEmail, hashTelefone, hashId] = await Promise.all([
            sha256Hex(normalizedName),
            sha256Hex(normalizedEmail),
            sha256Hex(normalizedPhone),
            sha256Hex(normalizedId),
        ]);

        const contentData = {
            content_name: property?.titulo || "Imóvel",
            content_category: property?.categoria?.nome || "Imóveis",
            content_ids: [property?.id || "N/A"],
            content_type: "product",
            currency: "BRL",
            value: property?.preco_venda || 0,
        };

        // Perna CAPI (server-side /api/meta-capi): PII hasheada no CLIENTE (crypto.subtle); o token
        // é resolvido por host no servidor (nunca no cliente). IP + User-Agent entram no servidor.
        sendMetaCapiEvent({
            site,
            eventName: 'Lead',
            eventId,
            customData: contentData,
            userData: {
                fn: hashNome ? [hashNome] : [],
                em: hashEmail ? [hashEmail] : [],
                ph: hashTelefone ? [hashTelefone] : [],
                external_id: hashId ? [hashId] : [],
            },
        });

        // Perna browser (window.fbq via trackMetaEvent) — MESMO eventId → dedup com a CAPI.
        // Substitui o react-facebook-pixel (import()/init() falhava mudo no bundle de produção).
        trackMetaEvent(site, 'Lead', contentData, { eventId });
    })();
};
